export default "__VITE_ASSET__D2c0kCzm__"